// @/api/model/user.js

import config from "@/config";
import http from "@/utils/request";


export default {

	iconData: {
		url: `${config.MAIN_URL}/api/v1/flyElement/file`,
		name: '获取icon图标',
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},

	file: {
		url: `${config.MAIN_URL}/api/v1/flyElement/file`,
		name: '飞行要素文件夹集合',
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},

	roundDotList: {
		url: `${config.MAIN_URL}/api/v1/company/flyElements`,
		name: "获取飞行要素标绘列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},

	roundDotListAll: {
		// http://192.168.6.76:8788/gaefb/api/v1/company/flyElements/all?elementType=
		url: `${config.MAIN_URL}/api/v1/company/flyElements/all?`,
		name: "返回某一类全部飞行要素标绘数据",
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},

	status: {
		url: `${config.MAIN_URL}/api/v1/flyElement/status`,
		name: '下发/取消下发',
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},

	addRound: {
		url: `${config.MAIN_URL}/api/v1/flyElement`,
		name: '添加飞行要素标绘',
		post: async function (data = {}) {
			return await http.post(this.url,data);
		},
	},

	deleteEl: {
		url: `${config.MAIN_URL}/api/v1/flyElement`,
		name: '删除飞行要素标绘',
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},

	editEl: {
		url: `${config.MAIN_URL}/api/v1/flyElement`,
		name: '修改飞行要素标绘',
		put: async function (data = {}) {
			return await http.put(this.url,data);
		},
	},

	zuheRoundDt:{
		url: `${config.MAIN_URL}/flyElement/Combination/queryByPage`,
		name: "获取组合标绘列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	
	addStatus: {
		url: `${config.MAIN_URL}/flyElement/Combination/updateStatus`,
		name: '下发/取消下发',
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},
	getflyElement: {
		url: `${config.MAIN_URL}/api/v1/flyElement/show`,
		name: '获取用户全部标绘的显示数据',
		get: async function (params) {
			return await http.get(this.url ,params);
		},
	},
	addDeleteEl: {
		url: `${config.MAIN_URL}/flyElement/Combination/deleteAssembly`,
		name: '删除组合标绘',
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},
	
	zHaddRound: {
		url: `${config.MAIN_URL}/flyElement/Combination/addAssembly`,
		name: '添加组合标绘',
		post: async function (data = {}) {
			return await http.post(this.url,data);
		},
	},
	
	zHeditEl: {
		url: `${config.MAIN_URL}/flyElement/Combination/updateAssembly`,
		name: '修改组合标绘',
		put: async function (data = {}) {
			return await http.put(this.url,data);
		},
	},
	flyElementShow: {
		url: `${config.MAIN_URL}/api/v1/flyElement/show`,
		name: "用户标绘显隐状态存储和删除",
		put: async function (params) {
			return await http.put(this.url ,params);
		},
	},

	dataList: {
		url: `${config.MAIN_URL}/api/v1/company/flyElements/any`,
		name: "飞行要素标绘列表圆多边形",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
};
